import { useSelector } from 'react-redux'
import { RootState } from '../redux'

export default function useRuuviTagAlertRules() {
  return useSelector((state: RootState) => state.ruuviTag.alertRules)
}
